import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { closeModal, isConsentUrl } from '../../Utils';
import { PsBeaconButton, PsBeaconIcon, PsBeaconModal } from '../shared/BeaconRegister';
import GenericError from '../shared/Errors/GenericError';

const FailureModal = () => {
    const onClose = () => {
        closeModal('co-client-failure-hub-error-modal');
    };

    const handleDispatch = () => {
        if (isConsentUrl()) {
            closeModal('co-client-failure-hub-error-modal');
            window.location.replace('/usis/advice/fps/profile');
        } else {
            closeModal('co-client-failure-hub-error-modal');
        }
    };

    return (
        <PsBeaconModal scale="normal" onClose={onClose} id="co-client-failure-hub-error-modal">
            <Box>
                <GenericError
                    id="general-hub-error"
                    title="Sorry, there was a problem sending the email.">
                    <Box sx={{ paddingBottom: '64px' }}>
                        Please continue planning. You can add a partner later in the process.
                    </Box>
                    <Box id="button-container" sx={{ display: 'flex', justifyContent: 'end' }}>
                        <Box sx={{ paddingRight: '12px' }}>
                            <PsBeaconButton variant="tertiary" onclick={onClose} size="normal">
                                Close
                            </PsBeaconButton>
                        </Box>
                        <PsBeaconButton variant="primary" onclick={handleDispatch} size="normal">
                            <PsBeaconIcon name='chevron_right' slot="suffix" fontSize="small" /> Continue Planning
                        </PsBeaconButton>
                    </Box>
                </GenericError>
            </Box>
        </PsBeaconModal>
    );
};

export default function CoClientFailure() {
    return <FailureModal />;
}
